import { render } from "./color.vue?vue&type=template&id=334501c0"
import script from "./color.vue?vue&type=script&lang=ts"
export * from "./color.vue?vue&type=script&lang=ts"
script.render = render

export default script